<!--
//  PageNotFound.vue
//
//  Created by Kalila L. on Dec 27 2020.
//  Copyright 2020 Vircadia contributors.
//
//  Distributed under the Apache License, Version 2.0.
//  See the accompanying file LICENSE or http://www.apache.org/licenses/LICENSE-2.0.html
-->

<template>
    <v-app id="inspire">
        <v-main>
            <v-container
                class="fill-height"
                fluid
            >
                <v-row
                    align="center"
                    justify="center"
                >
                    <v-col
                        xl="4"
                        lg="4"
                        md="4"
                        xs="12"
                        sm="12"
                    >
                        <ErrorOccurred @close-dialog="redirect"></ErrorOccurred>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import ErrorOccurred from '../components/dialogs/ErrorOccurred'

export default {
    name: 'PageNotFound',
    props: {
        source: String
    },
    components: {
        ErrorOccurred
    },
    methods: {
        redirect: function () {
            this.$router.push({ name: 'Home' });
        }
    },
    created: function () {
        this.$store.commit('mutate', {
            property: 'error',
            with: {
                title: 'Oops.',
                code: '404',
                full: "We couldn't find the page you're looking for."
            }
        });
    }
}
</script>
